import { initialValues, schema, TagFormData } from '../../utils/forms/tag';
import { TagsPath } from '../../utils/routes';
import { ControlledSystemTextInput } from '../data/TextInput';
import { FormContainer } from './FormContainer';

interface FormProps extends Pick<React.ComponentProps<typeof FormContainer>, "headerOptions" | "actionsOptions" | "handlePostSubmit" | "handleCancelOverride" | "shouldRedirectAfterSubmit"> { }

export const TagForm: React.FC<FormProps> = (props) => {
    return (
        <FormContainer<TagFormData>
            title='Related topic'
            headerOptions={{
                show: false
            }}
            queryOptions={{
                enabled: true,
                basePath: TagsPath
            }}
            schema={schema}
            defaultValues={initialValues}
            {...props}
        >
            <Form />
        </FormContainer>
    )
}

const Form = () => {
    return (
        <div className='flex flex-col items-center md:grid md:grid-cols-2 md:items-start gap-4'>
            <div className='col-span-full'>
                <ControlledSystemTextInput
                    label='Name'
                    inputSize='full'
                    name='name'
                />
            </div>
        </div>
    )
}